import React from 'react'
import KeyDropPickup from '../components/keyDropPickup/KeyDropPickup'
import { hasPermission } from '../components/auth/login/Login';

const KeyDropPickUpPage = () => {

    const canReadKeyPickupDrop = hasPermission('Self-Guided Tours', "Key pickup & drop event", 'read');

    if (!canReadKeyPickupDrop) {
        window.location.href = '/no-permission';
        return null;
    }
    return (
        <div className='outletConainer'>
            <KeyDropPickup />
        </div>
    )
}

export default KeyDropPickUpPage
